import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useUpdateProjectQuestionCommentFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Comment/hooks/updateQuestionCommentFunction/useUpdateProjectQuestionCommentFunction';
import useUpdateTemplateQuestionCommentFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/Comment/hooks/updateQuestionCommentFunction/useUpdateTemplateQuestionCommentFunction';

const useUpdateQuestionCommentFunction = (questionId, isCustomQuestion) => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useUpdateProjectQuestionCommentFunction(
        questionId,
        isCustomQuestion,
    );

    const dataFromTemplate = useUpdateTemplateQuestionCommentFunction(
        questionId,
        isCustomQuestion,
    );

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return {};
};

export default useUpdateQuestionCommentFunction;
